import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GlobalSearchListComponent } from '@shared/components/global-search-list/global-search-list.component';
import { PageNotFoundComponent } from './core/errorpages/page-not-found/page-not-found.component';
import { LinkExpireComponent } from './core/errorpages/link-expire/link-expire.component';
import { UnauthorizedComponent } from './core/errorpages/unauthorized/unauthorized.component';
import { AuthGuard } from './core/guards/auth.guard';
import { HomeComponent } from './modules/home/components/home.component';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { MaintenanceGuard } from '@gah-core/guards/maintenance.guard';
import { MaintenanceComponent } from '@gah-core/errorpages/maintenance/maintenance.component';

const routes: Routes = [
  //GAHR1553
  { path: '',
    canActivateChild: [MaintenanceGuard],
    children: [  
  {
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent 
  },
  {
    path: 'user',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: 'user',
    loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'public',
    pathMatch: 'full',
    redirectTo: 'page-not-found',
  },
  {
    path: 'public',
    loadChildren: () => import('./modules/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'legal',
    loadChildren: () => import('./modules/legal/legal.module').then((m) => m.LegalModule),
  },

  {
    path: 'admin/titles',
    pathMatch: 'full',
    redirectTo: 'admin/titles/manage-titles',
  },
  {
    path: 'admin/titles',
    loadChildren: () => import('./modules/admin/titles/titles.module').then((m) => m.TitlesModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/theaters',
    loadChildren: () =>
      import('./modules/admin/theater/theater.module').then((m) => m.TheaterModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/manage-homepage',
    loadChildren: () =>
      import('./modules/admin/manage-homepage/manage-homepage.module').then(
        (m) => m.ManageHomepageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'admin/manage-title-assets',
    pathMatch: 'full',
    redirectTo: 'page-not-found',
  },
  {
    path: 'admin/manage-title-assets',
    loadChildren: () =>
      import('./modules/admin/manage-assets/manage-assets.module').then(
        (m) => m.ManageAssetsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users',
    loadChildren: () =>
      import('./modules/admin/user-admin/user-admin.module').then((m) => m.UserAdminModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'assets',
    loadChildren: () => import('./modules/assets/assets.module').then((m) => m.AssetsModule),
  },
  {
    path: 'admin/asset-category-mapping',
    loadChildren: () =>
      import('./modules/admin/asset-mapping/asset-mapping.module').then(
        (m) => m.AssetMappingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/campaign',
    loadChildren: () =>
      import('./modules/admin/campaign/campaign.module').then((m) => m.CampaignModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'global-search',
    component: GlobalSearchListComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Global Search',
      breadcrumb: [
        {
          label: '{{territoryName}}',
          url: '/',
        },
      ],
    },
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'link-expire',
    component: LinkExpireComponent,
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home | {{territoryName}}',
      breadcrumb: [
        {
          label: '{{territoryName}}',
          url: '/',
        },
      ],
    },
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }